import React, { useState } from "react";
import { db } from "../firebaseConfig"; 
import { collection, addDoc } from "firebase/firestore";

const FleetPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    investmentAmount: "",
    carTypes: "",
    numberOfInvestors: "1",
    additionalDetails: "",
  });
  const [errorMessage, setErrorMessage] = useState("");

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.name ||
      !formData.email ||
      !formData.phone ||
      !formData.investmentAmount ||
      formData.investmentAmount < 500000
    ) {
      setErrorMessage(
        "Please fill out all required fields and ensure the investment amount is at least $500,000."
      );
      return;
    }

    setErrorMessage("");

    try {
      await addDoc(collection(db, "fleetRequests"), {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        investmentAmount: Number(formData.investmentAmount),
        carTypes: formData.carTypes,
        numberOfInvestors: Number(formData.numberOfInvestors),
        additionalDetails: formData.additionalDetails,
        createdAt: new Date(),
      });

      alert("Your fleet request has been submitted. Our team will contact you shortly.");
      setFormData({
        name: "",
        email: "",
        phone: "",
        investmentAmount: "",
        carTypes: "",
        numberOfInvestors: "1",
        additionalDetails: "",
      });
    } catch (error) {
      console.error("Error submitting fleet request:", error);
      alert("There was an error processing your request. Please try again later.");
    }
  };

  return (
    <div
      style={{
        backgroundImage: `url(${require("./back6.png")})`, 
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        minHeight: "100vh",
        padding: "20px",
      }}
    >
      <div 
        style={{
          maxWidth: "800px", 
          margin: "auto", 
          padding: "20px", 
          textAlign: "center",
          backgroundColor: "rgba(255, 255, 255, 0)"  // Semi-transparent background
        }}
      >
        <h1 style={{ color: "white", marginBottom: "20px", fontSize: "3em" }}>Create a Fleet</h1>
        <p style={{ fontSize: "1.1em", color: "white" }}>
          For investments over <strong>$500,000</strong>, create your own fleet of vehicles.
          GearShare offers exclusive opportunities for profit-driven vehicle investments. Fleets can
          be shared with other locations or establish new ones based on the investment scale.
        </p>
        <p style={{ fontSize: "1.1em", color: "white", marginTop: "20px" }}>
          Have questions? Call us directly at <strong style={{ color: "black" }}>1-800-555-GEAR</strong>.
        </p>

        <form
          onSubmit={handleSubmit}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "15px",
            padding: "20px",
            border: "1px solid #ddd",
            borderRadius: "8px",
            backgroundColor: "rgba(249, 249, 249, 0.8)", 
            marginTop: "30px",
          }}
        >
          <div style={{ marginBottom: "15px", textAlign: "left" }}>
            <label style={{ fontWeight: "bold", display: "block", marginBottom: "5px", color: "black" }}>
              Name:
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
              placeholder="Enter your name"
              style={{
                width: "95%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
              }}
            />
          </div>

          <div style={{ marginBottom: "15px", textAlign: "left" }}>
            <label style={{ fontWeight: "bold", display: "block", marginBottom: "5px", color: "black" }}>
              Email:
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              required
              placeholder="Enter your email"
              style={{
                width: "95%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
              }}
            />
          </div>

          <div style={{ marginBottom: "15px", textAlign: "left" }}>
            <label style={{ fontWeight: "bold", display: "block", marginBottom: "5px", color: "black" }}>
              Phone Number:
            </label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              required
              placeholder="Enter your phone number"
              style={{
                width: "95%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
              }}
            />
          </div>

          <div style={{ marginBottom: "15px", textAlign: "left" }}>
            <label style={{ fontWeight: "bold", display: "block", marginBottom: "5px", color: "black" }}>
              Investment Amount (minimum $500,000):
            </label>
            <input
              type="number"
              name="investmentAmount"
              value={formData.investmentAmount}
              onChange={handleInputChange}
              required
              placeholder="Enter investment amount"
              min="500000"
              style={{
                width: "95%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
              }}
            />
          </div>

          <div style={{ marginBottom: "15px", textAlign: "left" }}>
            <label style={{ fontWeight: "bold", display: "block", marginBottom: "5px", color: "black" }}>
              Preferred Car Types:
            </label>
            <textarea
              name="carTypes"
              value={formData.carTypes}
              onChange={handleInputChange}
              placeholder="E.g., Sports cars, SUVs, Classics"
              style={{
                width: "95%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                minHeight: "60px",
              }}
            ></textarea>
          </div>

          <div style={{ marginBottom: "15px", textAlign: "left" }}>
            <label style={{ fontWeight: "bold", display: "block", marginBottom: "5px", color: "black" }}>
              Number of Investors (max 5):
            </label>
            <select
              name="numberOfInvestors"
              value={formData.numberOfInvestors}
              onChange={handleInputChange}
              required
              style={{
                width: "98%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
              }}
            >
              {[...Array(5).keys()].map((i) => (
                <option key={i + 1} value={i + 1}>
                  {i + 1}
                </option>
              ))}
            </select>
          </div>

          <div style={{ marginBottom: "15px", textAlign: "left" }}>
            <label style={{ fontWeight: "bold", display: "block", marginBottom: "5px", color: "black" }}>
              Additional Details:
            </label>
            <textarea
              name="additionalDetails"
              value={formData.additionalDetails}
              onChange={handleInputChange}
              placeholder="Provide any other details about your fleet request"
              style={{
                width: "95%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                minHeight: "60px",
              }}
            ></textarea>
          </div>

          {errorMessage && (
            <p style={{ color: "red", fontWeight: "bold", marginBottom: "20px" }}>
              {errorMessage}
            </p>
          )}

          <button
            type="submit"
            style={{
              padding: "15px",
              backgroundColor: "#007bff",
              color: "#fff",
              fontWeight: "bold",
              fontSize: "1.2em",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Submit Fleet Request
          </button>
        </form>
      </div>
    </div>
  );
};

export default FleetPage;
